export const VIEW_SCHEDULE_PAGE_TRACKINGS = {
  bulkAddSuperBatches: 'bulk_add_super_batches',
  bulkRemoveSuperBatches: 'bulk_remove_super_batches',
  bulkUpdateInstructors: 'bulk_update_instructors',
  bulkDeleteClasses: 'bulk_delete_classes',
  deleteClass: 'delete_class',
  updateInstructors: 'update_instructors',
};
